import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";

interface Option {
  value: string | number;
  label: string;
}

interface MultiSelectFilterProps {
  label: string;
  value: any[];
  onChange: (values: any[]) => void;
  options: Option[];
}

export default function MultiSelectFilter({ label, value, onChange, options }: MultiSelectFilterProps) {

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={(e) => onChange(typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value)}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) =>
          options
            .filter((opt) => selected.includes(opt.value))
            .map((opt) => opt.label)
            .join(", ")
        }
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            <Checkbox checked={value.indexOf(opt.value) > -1} size="small" />
            <ListItemText primary={opt.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}